/**
 * useVisibilityPause — kept as a hook mount point for future visibility logic.
 * cancelQueries() was removed: it killed AI streams mid-response when the user
 * switched browser tabs.
 */
import { useEffect } from 'react'

export function useVisibilityPause() {
  useEffect(() => { /* no-op */ }, [])
}
